export default{
    whiteListApi:['/a','/b']
}